module.exports = __webpack_public_path__ + "img/alpine.041ca113.png";